import { DEFAULT_CHAIN } from '@/lib/chains'
import { Chain } from '@ourzora/chains'
import { BaseConnectedWalletType, ConnectedWallet } from '@privy-io/react-auth'
import { Address, createWalletClient, custom } from 'viem'

export async function walletClient({
  account,
  chain,
  wallet,
}: {
  account?: Address
  chain: Chain
  wallet: ConnectedWallet
}) {
  const provider = await wallet.getEthereumProvider()
  return createWalletClient({
    account,
    chain,
    transport: custom(provider),
  })
}

export const handleWalletConnection = async (
  wallet: BaseConnectedWalletType
): Promise<Array<{ address: Address; walletClientType: string }>> => {
  if (wallet.type === 'ethereum') {
    const provider = await wallet.getEthereumProvider()
    const client = createWalletClient({
      chain: DEFAULT_CHAIN,
      transport: custom(provider),
    })
    const addresses = await client.getAddresses()
    return addresses.map((address) => ({
      address,
      walletClientType: wallet.walletClientType,
    }))
  }
  return []
}
